export interface ExternalMediaInfo {
  name?: string;
  type?: string;
  size?: number;
  width?: number | null;
  height?: number | null;
  contentType?: string;
}

export interface ExternalUploadedMediaData {
  uuid?: string;
  preview_image_url?: string;
  orientation?: string | null;
  original_asset?: string | null;
  thumbnail_url?: string | null;
  api_url?: string | null;
  uploadPreset?: unknown;
}

export const buildExternalMediaItem = (
  uploadedMedia: ExternalUploadedMediaData,
  media: ExternalMediaInfo
) => ({
  id: uploadedMedia?.uuid,
  uuid: uploadedMedia?.uuid,
  name: media?.name,
  preview_image: uploadedMedia?.preview_image_url,
  orientation: uploadedMedia?.orientation,
  media_type: media?.type,
  video_duration: null,
  file_size: media?.size,
  width: media?.width,
  height: media?.height,
  uploadPreset: uploadedMedia?.uploadPreset,
  file_type: media?.contentType,
  assetBlob: uploadedMedia?.original_asset,
  source_media_uuid: null,
  previewImageURL: uploadedMedia?.preview_image_url,
  thumbnail_image: uploadedMedia?.thumbnail_url,
  original_asset: uploadedMedia?.original_asset,
  api_url: uploadedMedia?.api_url
});
